module.exports = __webpack_public_path__ + "static/media/cpLogo.53b2ad71.png";